import { render, staticRenderFns } from "./GuestMealsView.vue?vue&type=template&id=6882f686"
import script from "./GuestMealsView.vue?vue&type=script&lang=js"
export * from "./GuestMealsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports